<template>
  <q-page padding>
    <div class="row col-12 q-mb-md">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Biometrias Faciais Cadastradas:
      </p>
    </div>
    <q-btn
      dense
      flat
      label="Deletar Imagens"
      icon="delete"
      color="negative"
      size="sm"
      class="row justify-end q-mt-md q-mb-md"
      @click="deletarDialog = true"
    />
    <span
      v-if="imagensCadastradas.length == 0"
      class="q-mt-lg"
      style="
        background-color: red;
        padding: 15px;
        color: white;
        font-weight: bold;
        border-radius: 5px;
        display: flex;
        font-size: 20px;
        justify-content: center;
        align-items: center;
        text-align: center;
        margin-top: 125px;
      "
      ><span style="">
        Não existem biometriais faciais cadastradas neste usuário</span
      ></span
    >

    <div class="row q-col-gutter-md">
      <div
        class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
        v-for="(imagem, index) in imagensCadastradas"
        :key="index"
      >
        <q-card class="q-pa-sm">
          <div class="relative-position">
            <q-img
              :src="imagem.imagemAssinada"
              fit="contain"
              class="rounded-borders"
              style="height: 200px; background-color: #f5f5f5"
              spinner-color="primary"
            />
          </div>
          <div class="row justify-around items-center">
            <q-btn
              dense
              flat
              label="Visualizar Imagem"
              icon="visibility"
              color="positive"
              size="sm"
              @click="showImage(imagem.imagem_original, index)"
            />
            <div class="column justify-center items-center q-mt-sm">
              <span>{{
                imagem?.created_at?.split(" ")[0].split("-").reverse().join("/")
              }}</span>
              <span>{{ imagem?.created_at?.split(" ")[1] }}</span>
            </div>
          </div>
        </q-card>
      </div>
    </div>
    <dialog-info-design
      mensagem="Deletar Imagem?"
      subMensagem="Tem certeza que deseja deletar essa imagem?"
      :exibir="deletarDialog"
      :showCancelar="true"
      @resultado="deletarImagem"
    />
  </q-page>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
import DialogInfoDesign from "../../../../components/DialogInfoDesign.vue";
export default {
  components: { DialogInfoDesign },
  setup() {
    const route = useRoute();
    const store = useStore();
    const id = route.params.id;
    const quasar = useQuasar();
    const user = ref("");
    const deletarDialog = ref(false);
    const imgIndex = ref(0);
    const imagensCadastradas = ref([]);

    const getData = async () => {
      try {
        let response = await store.dispatch("user/getBiometriaCadastrada", {
          user_id: id,
        });

        if (response.data.data[0].templates.length === 0) {
          quasar.notify({
            message: "Nenhuma biometria facial cadastrada",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
        imagensCadastradas.value = response.data.data[0].templates;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const deletarImagem = async (resultado) => {
      if (resultado) {
        try {
          await store.dispatch("user/deletarImagem", {
            userId: id,
          });

          quasar.notify({
            message: "Biometria facial deletada com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });

          getData();
          imagensCadastradas.value = [];
        } catch (error) {
          console.log(error);
          quasar.notify({
            message: "Erro ao deletar biometria facial",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    onMounted(getData);
    const showImage = async (imageUrl, index) => {
      let assinado = await store.dispatch("user/assinarBiometriaCadastrada", {
        image_url: imageUrl,
      });

      imagensCadastradas.value[index].imagemAssinada = assinado.data.data;
      console.log(imagensCadastradas.value[index]);
    };

    return {
      getData,
      user,
      imagensCadastradas,
      showImage,
      deletarImagem,
      deletarDialog,
      imgIndex,
    };
  },
};
</script>

<style scoped>
.font {
  font-size: 20px;
}
</style>
